const en_facility_master = {

}

export default en_facility_master;